<template>
  <div
    id="emotion"
    :class="`card px-${space} py-${space} mt-${space} wrapper-emotion`"
    v-if="items.length > 0 && items[0].total > 0"
  >
    <div>
      <button :class="isPanel ? 'font-size-title': ''" class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="far fa-grin-beam"></i>
        {{ this.$t('reports.emotion.emotionLabel') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <!-- <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div> -->
        <b-table
          :items="[0, 1, 2, 3, 4]"
          caption-bottom
          :fields="fields"
          sort-icon-left
        >
          <template v-slot:cell(question)>
            <div class="mt-2">
              <idx-skeleton width="180" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(progress)>
            <div class="mt-2">
              <idx-skeleton width="50" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(score)>
            <div class="text-right">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(total)>
            <div class="text-center">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <b-table :id="isPanel ? 'size-panels' : ''" :items="items" :fields="fields" caption-bottom sort-icon-left>
          <template v-slot:cell(progress)="row">
            <div v-if="row.item.type !== 'total'" class="form" :style="`font-size: ${fontSize}px;`">
              <div class="progress-info">
                <div class="f-left">
                  {{ row.item.likes }}
                  <i class="far fa-smile-o"> </i>
                </div>
                <div class="f-right">
                  <i class="far fa-frown-o"> </i>
                  {{ row.item.dislikes }}
                </div>
              </div>
              <div>
                <b-progress
                  :value="row.item.progress"
                  :precision="1"
                  :max="100"
                ></b-progress>
              </div>
            </div>
          </template>
          <template v-slot:cell(score)="row">
            <div v-if="row.item.type !== 'total'" class="text-left" :style="`font-size: ${fontSize}px;`">
              {{ row.item.score }}%
            </div>
          </template>
          <template v-slot:cell(total)="row" :style="`font-size: ${fontSize}px;`">
            <div class="text-left">
              {{ row.item.total }}
            </div>
          </template>
          <!-- <template v-slot:table-caption>
            <div class="text-right px-3">
              Total de respostas válidas: {{ total }}
            </div>
          </template> -->
        </b-table>
        <div v-if="!isPanel" class="row">
          <div class="col-12 mt-2 text-right">
            <a
              @click="exportToXLS"
              :title="`${this.$t('reports.exportXlsLabel')}`"
            >
              <span class="xls">
                <i class="fas fa-file-download"></i>
              </span>
            </a>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import api from '@/services/api';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import EventBus from '../../../../../../eventBus';

export default {
  name: 'ScoreCsat',
  props: ['showCollapsed', 'dataGraph'],
  components: {
    idxSkeleton,
  },
  data: () => ({
    isBusy: false,
    filter: null,
    userAuth: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    emotionData: [],
    loader: false,
    items: [],
    fields: [],
    totalAnswers: 0,
    lang: 'br',
    isPanel: false,
    space: 2,
    fontSize: 16,
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountEmotion();
    },
    myActionId: function watchMyActionId() {
      this.mountEmotion();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountEmotion();
    },
    myIh1: function watchMyIh1() {
      this.mountEmotion();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.mountEmotion();
    },
    myIh2: function watchMyIh2() {
      this.mountEmotion();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.mountEmotion();
    },
    calendarDates: function watchDates() {
      this.mountEmotion();
    },
    myMetric: function watchMyMetric() {
      this.mountEmotion();
    },
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
      this.mountEmotion();
    },
  },
  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    async mountEmotion() {
      this.loader = true;
      const response = await api.get(`reports/get-emotions`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          lang: this.lang,
        },
      });
      this.emotionData = response.data;
      this.items = [];
      this.emotionData.map((obj) => {
        this.items.push({
          question: obj.question,
          progress: obj.percentil,
          score: obj.percentil.toFixed(2),
          likes: obj.percentil.toFixed(2),
          dislikes: (100 - obj.percentil).toFixed(2),
          total: obj.total,
        });
        this.total = this.total + obj.total;
      });
      this.totalAnswers = 0;
      for (let i = 0; i < this.items.length; i += 1) {
        this.totalAnswers += this.items[i].total;
      }
      this.items.push({
        question: this.$t('reports.emotion.totalAnswersLabel'),
        type: 'total',
        total: this.totalAnswers,
      });
      this.loader = false;
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportToXLS() {
      const header = [
        this.$t('reports.emotion.addQuestionLabel'),
        this.$t('reports.emotion.scoreLabel'),
        this.$t('reports.emotion.totalLabel'),
      ];
      const arr = [];
      this.items.forEach((el) => {
        arr.push({
          [this.$t('reports.emotion.addQuestionLabel')]: el.question,
          [this.$t('reports.emotion.scoreLabel')]: el.score,
          [this.$t('reports.emotion.totalLabel')]: el.total,
        });
      });
      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('rankings-emotion');
      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['rankings-emotion'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );
      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'rankings-emotion.xlsx');
      document.body.appendChild(link);
      link.click();
    },
    async mountCardPanel(data) {
      this.loader = true;
      const response = await api.get(`reports/get-emotions`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: null,
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          startDate: '2022-01-01',
          endDate: '2022-07-08',
          ih1: data.ih1 ? data.ih1._id : null,
          // period: data.period ? data.period : null,
          metric: data.metric ? data.metric : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          // indicatorRange: this.indicatorData.range,
          lang: this.lang,
        },
      });
      this.emotionData = response.data;
      this.items = [];
      this.emotionData.map((obj) => {
        this.items.push({
          question: obj.question,
          progress: obj.percentil,
          score: obj.percentil,
          likes: obj.percentil.toFixed(1),
          dislikes: (100 - obj.percentil).toFixed(1),
          total: obj.total,
        });
        this.total = this.total + obj.total;
      });
      this.totalAnswers = 0;
      for (let i = 0; i < this.items.length; i += 1) {
        this.totalAnswers += this.items[i].total;
      }
      this.items.push({
        question: this.$t('reports.emotion.totalAnswersLabel'),
        type: 'total',
        total: this.totalAnswers,
      });
      this.loader = false;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.emotion.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      { key: 'progress', class: 'progressTh' },
      {
        key: 'score',
        label: this.$t('reports.emotion.scoreLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'total',
        label: this.$t('reports.emotion.totalLabel'),
        sortable: true,
        class: 'totalTh',
      },
    ];
  },
  mounted() {
    this.visible = !this.showCollapsed;
    this.lang = this.$i18n.locale;
    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      this.mountCardPanel(this.dataGraph);
      EventBus.$on('update-emotion', (items) => {
        this.mountCardPanel(items);
      });
      this.space = 0;
    } else {
      this.mountEmotion();
      EventBus.$on('filter-rankings', () => {
        this.mountEmotion();
      });
      this.space = 2;
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-emotion .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-emotion .btn .btn-light .collapsed {
  background-color: transparent;
}
.progress-info {
  font-size: 12px;
  display: ruby-text;
}
.f-left {
  float: left;
}
.f-right {
  float: right;
}
.likesTh {
  padding-right: 0px !important;
  padding-top: 5px !important;
  font-size: 12px;
}
.dislikesTh {
  padding-left: 0px !important;
  padding-top: 5px !important;
  font-size: 12px;
}
.progress {
  background-color: #d62027;
}
.fa-smile-o {
  color: #4ce595;
}
.fa-frown-o {
  color: #d62027;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid #fff;
}
.card-panel {
  border: 1px solid #fff;
}
.wrapper-rankings.card-panel {
  min-height: 200px;
}
.form {
  display: grid;
  // position: absolute;
  width: 150px;
  right: 155px;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #1dc86e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/emotion.vue